export default __webpack_public_path__ + "static/media/high_resilience_score.6fce4607.svg";